import React from "react";
import DinnerHeader from "../../components/dinnerHeader";
import DinerFooter from "../../components/dinerFooter";
import WhatsAppButton from "../../components/whatsappButton";
import DinerMenuTab from "../../components/dinerMenuTab";
import LoadingDiv from "../../components/LoadingDiv";
import { connect } from "react-redux";
import { removeMobileView } from "../../redux/actions/chefMenuActions";
import { articleDetailAPI } from "../../core/services/Phase2APIservice";
import {
  EditorState,
  convertFromHTML,
  ContentState,
  convertToRaw,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import { GetPageDetail } from "../../backendUI/Page/config";
const html = `<p></p>`;

class ArticleData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createWithContent(
        ContentState.createFromText(html)
      ),
    };
    this.state = {
      isLoading: true,
      hideContent: window.matchMedia("(max-width: 991px)").matches,
      articleTag: "",
      articleTitle: "",
      articleContent: "",
    };
  }

  componentDidMount = () => {
    //chefp
    this.getArticleData();

    //quloe
    //this.getArticalDetails();
  };
  getArticalDetails = () => {
    GetPageDetail(this.props.match.params.slug).then((response) => {
      if (response.success == true) {
        var editorData = response.data.description;
        const blocksFromHtml = htmlToDraft(editorData);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap
        );
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          articleTag: response.data.name,
          articleTitle: response.data.title,
          editorState: editorState,
          isLoading: false,
        });
        console.log(response.data);
      }
    });
  };

  getArticleData = () => {
    return articleDetailAPI(this.props.match.params.slug)
      .then((response) => {
        if (response.data.status === 200) {
          /* this.setState({ cityArr: response.data.data }); */
          /*   console.log(response.data.data); */
          var editorData = response.data.data.article_content;
          const blocksFromHtml = htmlToDraft(editorData);
          const { contentBlocks, entityMap } = blocksFromHtml;
          const contentState = ContentState.createFromBlockArray(
            contentBlocks,
            entityMap
          );
          const editorState = EditorState.createWithContent(contentState);
          this.setState({
            articleTag: response.data.data.tag_title,
            articleTitle: response.data.data.article_title,
            editorState: editorState,
            isLoading: false,
          });
        } else {
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        /* console.log(error); */
        this.setState({
          isLoading: false,
        });
      });
  };
  render() {
    console.log(this.state.editorState);
    return (
      <div className="css2">
        <header>
          <div className="container menu_wrapper">
            <div className="logo">
              <a href="/">
                <img src="/assets/images/chef-pin.png" alt="Chef Pin" />
              </a>
            </div>
            <div id="nav-icon" className=" d-block d-xl-none">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <ul className="dinner_menu">
              <li className="active">
                {" "}
                <a href="/" className="login_btn">
                  Home
                </a>{" "}
              </li>
              <li className="">
                {" "}
                <a href="/diner-aboutus" className="login_btn">
                  About Us
                </a>{" "}
              </li>
              <li className="">
                {" "}
                <a
                  href="https://wa.me/919899622242"
                  target="_blank"
                  className="login_btn"
                >
                  Contact Us
                </a>{" "}
              </li>
              <li className="">
                {" "}
                <a href="/pick-city" className="login_btn">
                  Pick A City
                </a>{" "}
              </li>
              <li className="">
                {" "}
                <a href="/blog" className="login_btn">
                  Blog
                </a>{" "}
              </li>
              <li className="d-block d-xl-none last_btn">
                <a className="btn register_btn" href="/chef-homepage">
                  <span className="my_acc_text">Join Us AS a Home Chef</span>
                </a>
              </li>
            </ul>
            <ul className="dinner_menu d-none d-xl-block">
              <li>
                <a className="btn register_btn" href="/chef-homepage">
                  <span className="my_acc_text">Join Us AS a Home Chef</span>
                </a>
              </li>
            </ul>
            <div className="menu_overlay"></div>
          </div>
        </header>
        {this.state.isLoading ? (
          <LoadingDiv />
        ) : (
          <section className="love_cook py-5 article_section">
            <div className="container">
              <span className="text-center">
                <h2 className="text-uppercase color_C07 mb-2 mb-md-3 top_title">
                  {this.state.articleTag}
                </h2>
                <h1 className=" color_a05">{this.state.articleTitle}</h1>
              </span>
              {/* <div
                className="backend_text"
                dangerouslySetInnerHTML={{
                  __html:
                    this.state.articleContent &&
                    this.state.articleContent.replace(
                      /href/g,
                      `target='_blank' href`
                    ),
                }}
              ></div> */}
              <Editor
                toolbarHidden
                editorState={this.state.editorState}
                readOnly
              />
            </div>
          </section>
        )}
        <div className={this.state.hideContent ? "nofooter" : null}>
          <WhatsAppButton />
        </div>
        {this.state.hideContent ? <DinerMenuTab /> : <DinerFooter />}
      </div>
    );
  }
}

export default ArticleData;
